export default __webpack_public_path__ + "static/media/mustafa_pro_pic.42f137d7.jpg";